/**
 * Contacts endpoints
 */
export const contactsEndpoints = {
  list: () => '/api/quotes/contacts',
  detail: (email) => `/api/quotes/contacts/${encodeURIComponent(email)}`,
  create: () => '/api/quotes/contacts',
  update: (email) => `/api/quotes/contacts/${encodeURIComponent(email)}`,
  export: {
    csv: () => '/api/exports/contacts/csv',
    excel: () => '/api/exports/contacts/excel'
  }
}
